import Url from "@core/scripts/helper/url";
import fetchWithCSRF from "@core/scripts/helper/fetch-with-csrf";

const URL_PREFIX = "/ajax/size-advice";

function loadSizeAdviceWithoutErrorCatch(itemNumber) {
    const url = Url.toAbsolute(`${URL_PREFIX}/?itemNumber=${itemNumber}`);
    return fetchWithCSRF(url)
        .then(toJsonOrThrow(new Error("response was not okay")))
}

function toJsonOrThrow(error) {
    return (response) => {
        if(response.ok) {
            return response.text().then(text => {
                if (text) {
                    return JSON.parse(text);
                } else {
                    return null;
                }
            });
        }
        throw error;
    };
}

export default {
    loadSizeAdviceWithoutErrorCatch
}